import { gql } from 'apollo-boost';

const deleteLeadGQL = gql`
  mutation leads($id: String!) {
    deleteLead(id: $id)
  }
`;

export default deleteLeadGQL;
